export default __webpack_public_path__ + "static/media/image.30ee0f0f.png";